(function () {
  window.dataLayer = window.dataLayer || [];
  function track(eventName, parameters) {
    var payload = Object.assign({ event: eventName, page_path: window.location.pathname }, parameters || {});
    window.dataLayer.push(payload);
  }
  document.addEventListener('click', function (event) {
    var help = event.target.closest('.lantee-product-help-link');
    if (help) track('lantee_product_help_click');
    var details = event.target.closest('.lantee-card-details');
    if (details) track('lantee_product_card_click', { collection_path: window.location.pathname });
    var guide = event.target.closest('.lantee-collection-guide__grid--catalog a');
    if (guide) track('lantee_buying_guide_click', { destination: guide.getAttribute('href') });
  });
  document.addEventListener('submit', function (event) {
    var finder = event.target.closest('[data-lantee-finder]');
    if (finder) track('lantee_part_finder_submit', { finder_mode: finder.getAttribute('data-lantee-finder') });
  });
  document.addEventListener('change', function (event) {
    if (!event.target.matches('.facets input, .facets select, .mobile-facets input, .mobile-facets select')) return;
    var details = event.target.closest('details');
    var label = details && details.querySelector('summary');
    track('lantee_filter_used', { filter_name: label ? label.textContent.replace(/\s+/g, ' ').trim().slice(0, 60) : 'sort_or_filter' });
  });
  document.addEventListener('DOMContentLoaded', function () {
    if (window.location.pathname === '/search') {
      var grid = document.querySelector('#product-grid, .template-search__results');
      var cards = grid ? grid.querySelectorAll('.product-card-wrapper').length : 0;
      if (cards === 0) track('lantee_search_no_results');
    }
  });
})();